export default __webpack_public_path__ + "static/media/6.d7640a14.png";